var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMdiBellNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8772 11.79C19.3772 11.92 18.8772 12 18.3772 12C16.9193 11.9974 15.5219 11.4171 14.491 10.3862C13.4602 9.3553 12.8798 7.95788 12.8772 6.50001C12.8772 5.03001 13.4572 3.70001 14.3772 2.71001C14.1957 2.48755 13.9669 2.30838 13.7074 2.18555C13.4479 2.06272 13.1643 1.99934 12.8772 2.00001C11.7772 2.00001 10.8772 2.90001 10.8772 4.00001V4.29001C7.9072 5.17001 5.8772 7.90001 5.8772 11V17L3.8772 19V20H21.8772V19L19.8772 17V11.79ZM12.8772 23C13.9872 23 14.8772 22.11 14.8772 21H10.8772C10.8772 21.5304 11.0879 22.0391 11.463 22.4142C11.8381 22.7893 12.3468 23 12.8772 23Z",
    fill: "#C5C5CB",
    fillOpacity: 0.85
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3772 10C20.3072 10 21.8772 8.43 21.8772 6.5C21.8772 4.57 20.3072 3 18.3772 3C16.4472 3 14.8772 4.57 14.8772 6.5C14.8772 8.43 16.4472 10 18.3772 10Z",
    fill: "#F1935C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiBellNotification);
export default __webpack_public_path__ + "static/media/mdi_bell-notification.941191bc3d19ee2e2a43e1a629aa42f0.svg";
export { ForwardRef as ReactComponent };